import { render, staticRenderFns } from "./updataIssue.vue?vue&type=template&id=186830b1&scoped=true"
import script from "./updataIssue.vue?vue&type=script&lang=js"
export * from "./updataIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186830b1",
  null
  
)

export default component.exports